import { USER_SERVICE } from "@/services/users.service.js";
import router from '@/router/index';

const user = JSON.parse(localStorage.getItem('user'));
const state = user
    ? { status: { loggedIn: true }, user, processTask: undefined, getUsersOutput: {}, putUserChangeStatusOutput: false, getUserByIdOutput: {}, deleteUserOutput: {}, refresh:undefined }
    : { status: {}, user: null, processTask: undefined, getUsersOutput: {}, putUserChangeStatusOutput: false, getUserByIdOutput: {}, deleteUserOutput: {}, refresh: undefined };

const actions = {
    login({ dispatch, commit }, { username, password }) {
        dispatch('alert/clear', null, { root: true });
        commit('loginRequest', { username });
        
        USER_SERVICE.login(username, password)
            .then(
                user => {
                    if (user.data.role == "Admin"){
                        commit('loginSuccess', user);
                        router.push('/');
                    } else {
                        alert("Admin Credentials necessary");
                        localStorage.removeItem('user');
                    }
                    
                },
                error => {
                    commit('loginFailure', user);                
                    dispatch('alert/error', error, { root: true });

                }

            );
    },
    updatePassword({ dispatch, commit }, password) {
        dispatch('alert/clear', null, { root: true });
        commit('updatePasswordRequest');
        
        USER_SERVICE.updatePassword(password)
            .then(
                output => {
                    commit('updatePasswordSuccess', output);
                },
                error => {
                    commit('updatePasswordFailure', user);                
                    dispatch('alert/error', error, { root: true });

                }

            );
    },
    requestLinkPassword({ dispatch, commit }, email) {
        dispatch('alert/clear', null, { root: true });
        commit('linkRequest');

        USER_SERVICE.requestLink(email)
            .then(
                output => {
                    commit('linkSuccess');
                },
                error => {
                    commit('linkFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    resetPassword({ dispatch, commit }, {username, password, token}) {
        dispatch('alert/clear', null, { root: true });
        commit('resetPasswordRequest');

        USER_SERVICE.resetPassword(username, password, token)
            .then(
                output => {
                    commit('resetPasswordSuccess');
                },
                error => {
                    commit('resetPasswordFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    logout({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('logout');

        USER_SERVICE.logout();
    },
    //Service to get orders
    getUsers({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getUsersRequest');

        USER_SERVICE.getUsers(queryParams)
            .then(
                output => {
                    commit('getUsersSuccess', output);
                },
                error => {
                    commit('getUsersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to get user details by id
    getUserById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getUserByIdRequest');

        USER_SERVICE.getUserById(id)
            .then(
                output => {
                    commit('getUserByIdSuccess', output);
                },
                error => {
                    commit('getUserByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to update status
    putUserChangeStatus({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putUserChangeStatusRequest');

        USER_SERVICE.putUserChangeStatus(input)
            .then(
                output => {
                    commit('putUserChangeStatusSuccess', output);
                },
                error => {
                    commit('putUserChangeStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    //Service to remove Users
    deleteUser({ dispatch, commit }, input) {       
        dispatch('alert/clear', null, { root: true });
        commit('deleteUserRequest');

        USER_SERVICE.deleteUser(input)
            .then(
                output => {
                    commit('deleteUserSuccess', output);
                },
                error => {
                    commit('deleteUserFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    refreshToken({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('refreshRequest');
        
        /* Refresh the token and try again */
        USER_SERVICE.refreshToken(state.user.data.refreshToken, state.user.data.username)
        .then(user =>{
            commit('refreshSuccess', user);
       })
       .catch((error) => 
       {
            commit('refreshFailure', error);
            dispatch('alert/error', error, { root: true });
            dispatch('users/logout', null, { root: true });
       });
    },
};

const mutations = {
    /* Login */
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggedIn: true };
        state.user = user;

        // login successful if there's a jwt token in the response
        if (user.data && user.data.accessToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    /* Update password */
    updatePasswordRequest(state) {
        state.processTask = null;
    },
    updatePasswordSuccess(state) {
        state.processTask = true;
    },
    updatePasswordFailure(state) {
        state.processTask = false;
    },
    /* Request link */
    linkRequest(state) {
        state.processTask = undefined;
    },
    linkSuccess(state) {
        state.processTask = true;
    },
    linkFailure(state) {
        state.processTask = false;
    },
    /* Reset password */
    resetPasswordRequest(state) {
        state.processTask = null;
    },
    resetPasswordSuccess(state) {
        state.processTask = true;
    },
    resetPasswordFailure(state) {
        state.processTask = false;
    },
    /* */
    logout(state) {
        state.status = {};
        state.user = null;

        localStorage.removeItem('user');
        localStorage.removeItem('locale');

        router.go('/login'); // Force all modules to reset state
    },
    //getUsers
    getUsersRequest(state) {
    },
    getUsersSuccess(state, output) {
        state.getUsersOutput = output;
    },
    getUsersFailure(state) {
        state.getUsersOutput = false;
    },
    //getUserById
    getUserByIdRequest(state) {
    },
    getUserByIdSuccess(state, output) {
        state.getUserByIdOutput = output;
    },
    getUserByIdFailure(state) {
        state.getUserByIdOutput = false;
    },
    //putUserChangeStatus
    putUserChangeStatusRequest(state) {
        state.putUserChangeStatusOutput = null;
    },
    putUserChangeStatusSuccess(state, output) {
        state.putUserChangeStatusOutput = true;
    },
    putUserChangeStatusFailure(state) {
        state.putUserChangeStatusOutput = false;
    },
    //deleteUser
    deleteUserRequest(state) {
        state.deleteUserOutput = null;
    },
    deleteUserSuccess(state, output) {
        state.deleteUserOutput = true;
    },
    deleteUserFailure(state) {
        state.deleteUserOutput = false;
    },
    /* refreshToken */
    refreshRequest(state) {
        state.refresh = 'refreshing';
    },
    refreshSuccess(state, user) {
        state.user = user;

        // login successful if there's a jwt token in the response
        if (user && user.data && user.data.refreshToken) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(user));
        }

        state.refresh = true;
    },
    refreshFailure(state) {
        state.refresh = false;
    },
};

export const users = {
    namespaced: true,
    state,
    actions,
    mutations
};